import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { useState } from 'react';
import { useAlert } from '../../context/AlertContext';
import { ICompany } from '../../Interfaces/ICompany';
import { ICompanyFormationFullObject } from '../../Interfaces/ICompanyFormation';
import { IInheritFullObject } from '../../Interfaces/IInherit';
import { ILegalTransactionDataCollection } from '../../Interfaces/ILegalTransaction';
import {
  ILegalTransactionRelationship,
  initLegalTransactionRelationship,
} from '../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationship';
import { IMortgageFullObject } from '../../Interfaces/IMortgage';
import { IInheritHasPerson } from '../../Interfaces/IPerson';
import { IRealEstate } from '../../Interfaces/IRealEstate';

enum DataCollectionType {
  CompanyFoundation = 'Unternehmensgründung',
  CompanyChange = 'Unternehmensänderung',
  AssociationFoundation = 'Vereinsgründung',
  AssociationChange = 'Vereinsänderung',
  InheritanceApplication = 'Erbscheinsantrag',
  PurchaseContract = 'Kaufvertrag',
  Mortgage = 'Grundschuld',
}

interface IProps {
  relationships: ILegalTransactionRelationship[];
  setRelationships: React.Dispatch<
    React.SetStateAction<ILegalTransactionRelationship[]>
  >;
  dataCollection: ILegalTransactionDataCollection[];
  setDataCollection: React.Dispatch<
    React.SetStateAction<ILegalTransactionDataCollection[]>
  >;
  unmount: () => void;
}

export const AddLegalTransactionRelationshipDialog = ({
  unmount,
  relationships,
  setRelationships,
  dataCollection,
  setDataCollection,
}: IProps) => {
  const [selectedOption, setSelectedOption] = useState(
    DataCollectionType.CompanyFoundation
  );
  const { showAlert } = useAlert();

  const onSubmit = () => {
    if (
      selectedOption === DataCollectionType.CompanyFoundation ||
      selectedOption === DataCollectionType.CompanyChange ||
      selectedOption === DataCollectionType.AssociationFoundation ||
      selectedOption === DataCollectionType.AssociationChange
    ) {
      const newItem: ICompanyFormationFullObject = {
        AddressStreet: null,
        AddressStreetNr: null,
        AmountShares: 0,
        CompanyName: '',
        DateOfFormation: new Date(),
        idBusinessForm:
          selectedOption === DataCollectionType.AssociationFoundation ||
          selectedOption === DataCollectionType.AssociationChange
            ? 12
            : 8,
        idCompanyFormation: dataCollection.length * -1,
        idLegalTransaction: -1,
        idPostcode: 1,
        isFounding:
          selectedOption === DataCollectionType.CompanyFoundation ||
          selectedOption === DataCollectionType.AssociationFoundation,
        Postcode_AddressidPostcode: null,
        PurposeOfTheCompany: '',
        ShareCapital: 25000,
        Street: '',
        StreetNr: '',
        useSampleProtocol: false,
        ValuePerShare: 0,
        CompanyFormationAnswerArray: [],
        CompanyFormationHasShareHolderArray: [],
        CompanyFormationShareArray: [],
        DocumentArray: [],
        ShareHolderArray: [],
        LegalClientArray: [],
      };
      setDataCollection([...dataCollection, newItem]);
    } else if (selectedOption === DataCollectionType.InheritanceApplication) {
      const newItem: IInheritFullObject = {
        ChildrenArray: [],
        hasTestament: false,
        idInherit: dataCollection.length * -1,
        idLegalTransaction: -1,
        idPerson: -1,
        MarriageArray: [],
        LegalClientArray: [],
        PersonArray: [
          {
            isStranger: false,
            FirstName: '',
            LastName: '',
            idGender: 1,
            idAcademicTitle: 1,
            idBusinessForm: 1,
            idCountry: 1,
            Birthday: '',
            idPerson: -1,
            Bank: null,
            BIC: null,
            Birthplace: '',
            Email: null,
            IBAN: null,
            idInherit: -1,
            idPostcode: null,
            PhoneNumber: null,
            Street: '',
            StreetAditional: null,
            StreetNr: '',
            Surname: null,
            TaxNumber: null,
          } as IInheritHasPerson,
        ],
        PersonHasDocument: [],
      };
      setDataCollection([...dataCollection, newItem]);
    } else if (selectedOption === DataCollectionType.PurchaseContract) {
      setRelationships([...relationships, initLegalTransactionRelationship()]);
    } else if (selectedOption === DataCollectionType.Mortgage) {
      const IRealEstateObject = {
        idRealEstate: -1,

        Street: null,
        StreetNr: null,
        StreetAditional: null,
        idPostcode: null,
        // Adresse ODER Latitide als Pflich
        Latitude: null,
        Longitude: null,

        idCourt: -1,
        LandRegister: '',
        SheetLandRegister: '',
        Parcel: '',
        LandParcel: '',
        idPropertyType: -1,
        isBuild: false,

        Price: 100000,
        PriceInventoryOption: null,

        idRealEstateUseType: 1,
        idPurchaseContract: -1,

        Defect: null,
        Particularities: null,

        Area: null,
        BuildWith: null,
        EasementText: null,
        hasApartment: false,
        hasEasement: false,
        hasPartialArea: false,
        isMeasured: false,
        Manager_idPerson: null,
        OrderMeasurement_idPurchaseContractRelationType: null,
        PaymentMeasurement_idPurchaseContractRelationType: null,
      } as IRealEstate;
      const companyObject = {
        Company: '',
        RegisterCourt: null,
        RegisterNumber: null,
        SalesTaxNumber: null,
        Street: '',
        StreetAditional: '',
        StreetNr: '',
        TaxNumber: null,
        idBusinessForm: 1,
        idCompany: -1,
        idPostcode: -1,
      } as ICompany;

      const newItem: IMortgageFullObject = {
        PersonArray: [],
        PersonHasDocument: [],
        idMortgage: -1,
        idPerson: -1,
        idLegalTransaction: -1,
        RealEstate: IRealEstateObject,
        NewMortgage: false,
        MortgageInterest: 0,
        AmountMortgage: 0,
        Beneficiary: '',
        BeneficiaryType: 'PRIVATE',
        BeneficiaryDetails: companyObject,
        PropertyForBuying: null,
        PropertyOwned: null,
        RealEstateLandRegistryData: '',
        Paragraph: false,
        id: 0,
        AdditionalServices: '',
        DocumentArray: [],
        ToBeDeleted: false,
        LegalClientArray: [],
      };
      setDataCollection([...dataCollection, newItem]);
      showAlert({
        text: 'Grundschuld erfolgreich angelegt. Legen Sie bitte einen Eigentümer und einen Begünstigten an!',
        duration: 10000,
      });
    }
    unmount();
  };

  return (
    <Dialog open={true} onClose={unmount}>
      <DialogTitle>Neue Datenerfassung hinzufügen</DialogTitle>
      <DialogContent>
        <FormControl fullWidth size='small' sx={{ mt: 2 }}>
          <InputLabel>Art der Datenerfassung</InputLabel>
          <Select
            value={selectedOption}
            label='Art der Datenerfassung'
            onChange={({ target: { value } }: SelectChangeEvent) =>
              setSelectedOption(value as DataCollectionType)
            }
          >
            {Object.values(DataCollectionType).map((type, i) => (
              <MenuItem key={i} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={unmount}>
          Abbruch
        </Button>
        <Button variant='contained' onClick={onSubmit}>
          Hinzufügen
        </Button>
      </DialogActions>
    </Dialog>
  );
};
